class ImageAccordion extends HTMLElement {
  constructor() {
    super()
    this.items = []
    this.currentOpenIndex = null
    this.imageContainer = null
    this.currentImg = null
    this.newImg = null
  }

  connectedCallback() {
    this.imageContainer = this.querySelector('.image-accordion__side-image')
    this.currentImg = this.querySelector('.image-accordion__side-image-current-img')
    this.newImg = this.querySelector('.image-accordion__new-image')
    this.items = [...this.querySelectorAll('.image-accordion__item')]

    this.items.forEach((item, index) => {
      const button = item.querySelector('.image-accordion__title button')
      button.addEventListener('click', () => this.toggleItem(index))
      button.addEventListener('keydown', e => this.handleKeydown(e, index))
    })

    if (this.hasAttribute('open-first')) {
      this.toggleItem(0)
    }
  }

  toggleItem(index) {
    if (this.currentOpenIndex !== null && this.currentOpenIndex !== index) {
      this.closeItem(this.currentOpenIndex)
    }

    const isOpen = this.currentOpenIndex === index

    if (isOpen) {
      this.closeItem(index)
      this.currentOpenIndex = null
    } else {
      this.openItem(index)
      this.currentOpenIndex = index
    }
  }

  openItem(index) {
    const item = this.items[index]
    const answer = item.querySelector('.image-accordion__a')
    const arrow = item.querySelector('.arrow')
    const button = item.querySelector('.image-accordion__title button')

    answer.style.display = 'block'
    arrow.classList.add('rotate')
    button.setAttribute('aria-expanded', 'true')

    this.updateImage(button.dataset.imageUrl, button.dataset.imageAlt)
  }

  closeItem(index) {
    const item = this.items[index]
    const answer = item.querySelector('.image-accordion__a')
    const arrow = item.querySelector('.arrow')
    const button = item.querySelector('.image-accordion__title button')

    answer.style.display = 'none'
    arrow.classList.remove('rotate')
    button.setAttribute('aria-expanded', 'false')
  }

  updateImage(url, alt) {
    if (!this.currentImg || !this.newImg) return

    this.newImg.src = url
    this.newImg.alt = alt
    this.newImg.style.display = 'block'
    this.newImg.style.opacity = '0'

    this.newImg.onload = () => {
      void this.newImg.offsetWidth

      this.newImg.style.transition = 'opacity 0.4s ease'
      this.currentImg.style.transition = 'opacity 0.4s ease'

      this.newImg.style.opacity = '1'
      this.currentImg.style.opacity = '0'

      const finishTransition = () => {
        this.currentImg.src = url
        this.currentImg.alt = alt
        this.currentImg.style.opacity = '1'

        requestAnimationFrame(() => {
          setTimeout(() => {
            this.newImg.style.opacity = '0'
            this.newImg.style.display = 'none'
          }, 400) // CSS transition duration
        })

        this.newImg.removeEventListener('transitionend', finishTransition)
      }

      this.newImg.addEventListener('transitionend', finishTransition)
    }
  }

  handleKeydown(e, index) {
    const total = this.items.length
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault()
      this.toggleItem(index)
    } else if (e.key === 'ArrowDown') {
      e.preventDefault()
      const next = (index + 1) % total
      this.items[next].querySelector('.image-accordion__title').focus()
    } else if (e.key === 'ArrowUp') {
      e.preventDefault()
      const prev = (index - 1 + total) % total
      this.items[prev].querySelector('.image-accordion__title').focus()
    }
  }
}

customElements.define('image-accordion', ImageAccordion)